import { Component, input, output, computed, signal, ChangeDetectionStrategy } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';
import { ICard } from '../../models/card.model';
import { RouterLink } from '@angular/router';
import { NavCommands } from '../../routing/route-builders';

@Component({
    selector: 'app-card-event',
    templateUrl: './card-event.component.html',
    styleUrls: ['./card-event.component.scss'],
    imports: [NgOptimizedImage, SkeletonModule, RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardEventComponent {
  card = input.required<ICard>();
  id = input.required<number>();
  width = input<string>('20rem');
  height = input<string>('18rem');
  imageHeight = input<string>('10.75rem');
  borderRadius = input<string>('0.3125rem');
  route = input<NavCommands | null>(null);

  handleClick = output<void>();

  imageLoaded = signal(false);

  borderRadiusTop = computed(() => {
    const radius = this.borderRadius();
    return `${radius} ${radius} 0px 0px`;
  });

  onImageLoad(): void {
    this.imageLoaded.set(true);
  }

  onCardClick(): void {
    if (!this.route()) {
      this.handleClick.emit();
    }
  }

  onCardKeydown(event: KeyboardEvent): void {
    if (!this.route() && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      this.handleClick.emit();
    }
  }
}
